<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t('navigations.add/edit site') }}</h2>
    </div>          
    <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
          <i class="fa fa-times close" @click="onclosed()"></i>
          <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
    </div>
  <div class="wrapper wrapper-content px-0">
    <div class="">
      <!-- site identification -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('siteIdentification')">
        <h4 class="text-primary mb-0">{{ $t("navigations.site identification") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.siteIdentification ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.siteIdentification">
        <div class="form-group row">
          <!-- site identification -->
          <div class="col-lg-4 mb-1">
            <label class="col-form-label"
              >{{$t('navigations.site code')}} <sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input type="text" class="form-control" v-model="value.siteCode"  maxlength="1000" :disabled="value.status === 'Enrolled'"/>
            <span class="errormsg animated bounce" v-if="errors[0]"> {{ $t('navigations.please enter site code') }} </span>
          </div>
          <div class="col-lg-8 mb-1">
            <label class="col-form-label">{{ $t('navigations.site name') }} <sup><i class="fa fa-asterisk required"></i></sup> </label>
            <input type="text"  maxlength="1000" class="form-control" v-model="value.siteName" :disabled="value.status === 'Enrolled'" />
             <span class="errormsg animated bounce" v-if="errors[1]"> {{ $t('navigations.please enter site name') }} </span>
          </div>
          
           
          <div class="col-lg-12">
            <div class="my-2 border-bottom">
              <h4>{{ $t("navigations.pi contact details") }}</h4>
            </div>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{ $t('navigations.role') }} </label>
            <select
                name="account"
                placeholder="Select roles"
                v-model="value.piContactDetails.role"
                @change="changePIRole()"
                class="form-select"
              >
                <option selected value="" disabled>{{ $t("navigations.select a role") }}</option>
                <option
                  v-for="options in roleList"
                  :value="options.roleID"
                  :key="options.role"
                  :options="roleList"
                  :hideSelected="false"
                  :closeOnSelect="false"
                  :searchable="true"
                  trackBy="roleName"
                >
                  {{ options.roleName }}
                </option>
            </select>
          </div>
           <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{ $t('navigations.e-mail') }} </label>
            <select
                v-model="value.piContactDetails.email"
                class="form-select"
                @change="userSelected"
              >
                <option disabled value="">{{ $t("navigations.select user") }}</option>
                <option
                  v-for="user in userList"
                  :key="user.userID"
                  :value="user.email"
                >
                  {{ user.email }}
                </option>
              </select>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{ $t('navigations.principal investigator name') }} </label>
            <input type="text" disabled v-model="value.piContactDetails.name" maxlength="1000" class="form-control"/>
          </div>
         
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{ $t('navigations.phone number') }} </label>
            <input type="text" v-model="value.piContactDetails.phone" maxlength="1000" class="form-control"/>
          </div>
          <div class="col-lg-12 mb-1">
            <label class="col-form-label">{{ $t('navigations.address') }} </label>
            <input type="text" v-model="value.piContactDetails.address" maxlength="1000" class="form-control"/>
          </div>
          <div class="col-lg-6 mb-1">
              <label class="col-form-label">{{ $t('navigations.subinvestigator role') }}</label>
              <select
                name="account"
                v-model="value.subInvestigator.role"
                @change="getSubInvestigators()"
                class="form-select"
              >
                <option disabled value="">{{ $t("navigations.select a role") }}</option>
                <option
                  v-for="role in roleList"
                  :key="role.roleID"
                  :value="role.roleID"
                >
                  {{ role.roleName }}
                </option>
              </select>
            </div>

            <div class="col-lg-6 mb-1">
              <label class="col-form-label">{{ $t('navigations.sub investigator') }}</label>
              <select
                v-model="value.subInvestigator.email"
                class="form-select"
                @change="subInvestigatorSelected"
              >
                <option disabled value="">{{ $t("navigations.select user") }}</option>
                <option
                  v-for="user in subInvestigators"
                  :key="user.userID"
                  :value="user.email"
                >
                  {{ user.email }}
                </option>
              </select>
            </div>

        </div>
      </div>
      
      <!-- site address & contact information -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('siteAddress')">
        <h4 class="text-primary mb-0">{{ $t("navigations.site address & contact information") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.siteAddress ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.siteAddress">
        <div class="form-group row">
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.street') }} </label>
            <input type="text" v-model="value.siteAddress.street" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.city') }} </label>
            <input type="text" v-model="value.siteAddress.city"  class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.state') }} </label>
            <input type="text" v-model="value.siteAddress.state" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{
              $t("navigations.country")
            }}</label>
            <select
              class="form-control"
              name="account"
              v-model="value.siteAddress.country"
            >
              <option v-for="country in countries" :key="country.id">
                {{ country.country }}
              </option>
            </select>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.post/zip code') }} </label>
            <input type="text" v-model="value.siteAddress.postalCode" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.institution / hospital name') }} </label>
            <input type="text" v-model="value.institutionName" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.department / unit') }} </label>
            <input type="text" v-model="value.department" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.primary site contact') }} </label>
            <input type="text" v-model="value.primarySiteContact" class="form-control" maxlength="1000"/>
          </div>

          <div class="col-lg-12">
            <div class="my-2 border-bottom">
              <h4>{{ $t("navigations.contact information") }}</h4>
            </div>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.e-mail') }} </label>
            <input type="email"  v-model="value.siteContactInfo.email" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.phone number') }} </label>
            <input type="tel" v-model="value.siteContactInfo.phone" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.fax') }} </label>
            <input type="text" v-model="value.siteContactInfo.fax" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.emergency contact') }} </label>
            <input type="tel" v-model="value.siteContactInfo.emergencyContact" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>  
      
      <!-- Regulatory & Ethics -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('regulatory')">
        <h4 class="text-primary mb-0">{{ $t("navigations.regulatory n ethics") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.regulatory ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.regulatory">
        <div class="form-group row">
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.irb/ec name') }} </label>
            <input type="text"  v-model="value.irbName" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.irb/ec reference no') }} </label>
            <input type="text" v-model="value.irbReferenceNo" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.approval date') }} </label>
            <input
              type="date"
              class="form-control my-md-2 my-lg-0"
              v-model="value.submissionDate"
           >
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.ethics expiry') }} </label>
            <input type="date" v-model="value.renewalDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.regulatory authority approval') }} </label>
            <input type="date" v-model="value.regulatoryAuthorityApproval" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>
      
      <!-- Site Status & Activation -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('siteStatus')">
        <h4 class="text-primary mb-0">{{ $t("navigations.site status & activation") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.siteStatus ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.siteStatus">
        <div class="form-group row">
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.current status') }} </label>
            <select v-model="value.currentStatus" class="form-control" name="">
              <option value="Planned">{{ $t('navigations.planned') }}</option>
              <option value="Open">{{ $t('navigations.active') }}</option>
              <option value="Visit Completed">{{ $t('navigations.closed') }}</option>
              <option value="Visit Completed">{{ $t('navigations.archived') }}</option>
            </select>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.status effective date') }} </label>
            <input type="date" v-model="value.statusEffectiveDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.planned site initiation visit date') }} </label>
            <input type="date" v-model="value.plannedSIVDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.actual siv date') }} </label>
            <input type="date" v-model="value.actualSIVDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">{{ $t('navigations.activation date') }} </label>
            <input type="date" v-model="value.activationDate" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>

      <!-- Enrollment & Performance -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('enrollment')">
        <h4 class="text-primary mb-0">{{ $t("navigations.enrollment & performance") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.enrollment ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.enrollment">
        <div class="form-group row">
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.target enrollment') }} </label>
            <input type="text" v-model="value.targetnrollment" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.actual enrollment') }} </label>
            <input type="text" v-model="value.actualEnrollment" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.screen failure tracking (optional)') }} </label>
            <input type="text" v-model="value.screeenFailureTracking" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.dropout tracking (optional)') }} </label>
            <input type="text" v-model="value.dropoutTracking" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>
      
      <!-- operational tracking -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('operational')">
        <h4 class="text-primary mb-0">{{ $t("navigations.operational tracking") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.operational ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.operational">
        <div class="form-group row">
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.last monitoring visit date') }} </label>
            <input type="date" v-model="value.lastmonitoringVisitDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.next monitoring visit planned date') }} </label>
            <input type="date" v-model="value.nextMonitoringVisitPlannedDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.site cra / monitor assigned') }} </label>
            <input type="text" v-model="value.siteCRA" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">{{ $t('navigations.site start-up specialist (if applicable)') }} </label>
            <input type="text" v-model="value.siteStartupSpecialList" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>
      
      <!-- Close out -->
      <div class="sect-head d-flex justify-content-between" @click="toggleSection('closeOut')">
        <h4 class="text-primary mb-0">{{ $t("navigations.close-out") }}</h4>
        <span class="section-toggle float-right">
          <i class="fa" :class="sectionState.closeOut ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
      <div class="sect-content pb-1 mb-2" v-show="sectionState.closeOut">
        <div class="form-group row">
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.close-out visit date') }} </label>
            <input type="date" v-model="value.closeoutVisitDate" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.archival status') }} </label>
            <input type="text" v-model="value.archivalStatus" class="form-control" maxlength="1000"/>
          </div>
          <div class="col-lg-4">
            <label class="col-form-label">{{ $t('navigations.final payment status') }} </label>
            <input type="text" v-model="value.finalPaymentStatus" class="form-control" maxlength="1000"/>
          </div>
        </div>
      </div>
      
      <div class="form-group row">  
      <div class="form-group"> 
        <div class="col-lg-6 my-3 d-flex">
          <div class="input-group date">
            <div class="i-checks">
              <label class="mr-2">{{ $t('navigations.active') }}</label>
              <input
                type="checkbox"
                checked="checked"
                value=""
                v-model="value.active"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-lg-end">
          <button
            class="cancel_btn py-1 px-4 mx-3"
            type="submit"
            @click="clear()"
          >
            {{ $t('navigations.clear') }}
          </button>
          <button class="save_btn py-1 px-4" type="submit" @click="save()">
             <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-else>{{ $t('navigations.save') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script src="./manage_site.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/savepages.css";
.wrapper-content {
  width: 100%;
}
textarea {
  width: 100%;
}
.imp {
  color: #ff0000;
  font-size: 7px;
}
.col-form-label {
  font-size: 14px;
}
.impcl {
  color: #ff4747;

  font-size: 25px;

  float: right;
}

.impcl:hover {
  color: #a30202;

  font-size: 25px;

  float: right;
}
.form-select{
  border-radius:0!important;
}
.form-select:focus{
  border-color:#145faf!important;
  box-shadow: 0 0 0!important;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.closetooltipposition{
  bottom: -10px !important;
  margin-left: -65px !important;
}
.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 110%; /* Position the tooltip above the icon */
  left: 10%;
  margin-left: -30px; /* Use half of the width to center-align */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

/* Import Section */
.ibox-dashed {
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 4px 4px;
  background-color: #f8fafc;
  transition: all 0.3s;
  margin-bottom: .25rem;
}

.ibox-dashed:hover {
  border-color: var(--primary);
  background-color: rgba(37, 99, 235, 0.05);
}


</style>